export const GET_TRAINEES_REQUEST = 'GET_TRAINEES_REQUEST'
export const GET_TRAINEES_SUCCESS = 'GET_TRAINEES_SUCCESS'
export const GET_TRAINEES_FAILURE = 'GET_TRAINEES_FAILURE'

export const ADD_TRAINEE_REQUEST = 'ADD_TRAINEE_REQUEST'
export const ADD_TRAINEE_SUCCESS = 'ADD_TRAINEE_SUCCESS'
export const ADD_TRAINEE_FAILURE = 'ADD_TRAINEE_FAILURE'
export const SHOW_DUPLICATE_TRAINEE_WARNING = 'SHOW_DUPLICATE_TRAINEE_WARNING'

export const ADD_DUPLICATE_TRAINEE_REQUEST = 'ADD_DUPLICATE_TRAINEE_REQUEST'
export const ADD_DUPLICATE_TRAINEE_SUCCESS = 'ADD_DUPLICATE_TRAINEE_SUCCESS'
export const ADD_DUPLICATE_TRAINEE_FAILURE = 'ADD_DUPLICATE_TRAINEE_FAILURE'

export const UPDATE_TRAINEE_REQUEST = 'UPDATE_TRAINEE_REQUEST'
export const UPDATE_TRAINEE_SUCCESS = 'UPDATE_TRAINEE_SUCCESS'
export const UPDATE_TRAINEE_FAILURE = 'UPDATE_TRAINEE_FAILURE'

export const UPDATE_DUPLICATE_TRAINEE_REQUEST = 'UPDATE_DUPLICATE_TRAINEE_REQUEST'
export const UPDATE_DUPLICATE_TRAINEE_SUCCESS = 'UPDATE_DUPLICATE_TRAINEE_SUCCESS'
export const UPDATE_DUPLICATE_TRAINEE_FAILURE = 'UPDATE_DUPLICATE_TRAINEE_FAILURE'

export const ARCHIVE_TRAINEE_REQUEST = 'ARCHIVE_TRAINEE_REQUEST'
export const ARCHIVE_TRAINEE_SUCCESS = 'ARCHIVE_TRAINEE_SUCCESS'
export const ARCHIVE_TRAINEE_FAILURE = 'ARCHIVE_TRAINEE_FAILURE'

export const UNARCHIVE_TRAINEE_REQUEST = 'UNARCHIVE_TRAINEE_REQUEST'
export const UNARCHIVE_TRAINEE_SUCCESS = 'UNARCHIVE_TRAINEE_SUCCESS'
export const UNARCHIVE_TRAINEE_FAILURE = 'UNARCHIVE_TRAINEE_FAILURE'



// WEBPACK FOOTER //
// ./src/constants/trainees.js